/*
*###############################################################################
*Module Name                   : StockReports.js                               #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  Minol Prageesha                              #
*Date                          : Monday, January 17th 2022, 1:53:30 pm         #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/


import React, { useState, useEffect } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPInfoBox from 'framework/layout/DPInfoBox'
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import { Button } from '@material-ui/core'

//**End Importing required componant files */

const StockReport = (props) => {



    //*** User Activity related states*/
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    //*** End User activity related staes */



    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    var time = process.env.REACT_APP_ALERTTIMEOUT

   // print Function
    async function handlesupplierStockPrint() {
        const authToken = localStorage.getItem("authToken")
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/StockReport/SupplierStock/admin`, {
            method: "GET",
            headers: { "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}` }
        }).then(Response => Response.json())
            .then(responseData => {

                if (responseData.success == true) {
                    {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                    }
                }
                SetLoadingAlert(false)
            })
    }

       // print Function
       async function handleLocationstockPrint() {
        const authToken = localStorage.getItem("authToken")
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report ...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/StockReport/locationStock/admin`, {
            method: "GET",
            headers: { "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}` }
        }).then(Response => Response.json())
            .then(responseData => {

                if (responseData.success == true) {
                    {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                    }
                }
                SetLoadingAlert(false)
            })
    }

       // print Function
       async function handleGroupstockPrint() {
        const authToken = localStorage.getItem("authToken")
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/GroupStock//admin/1`, {
            method: "GET",
            headers: { "Content-Type": "application/json" ,
            "Authorization": `Bearer ${authToken}`}
        }).then(Response => Response.json())
            .then(responseData => {

                if (responseData.success == true) {
                    {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                    }
                }
                SetLoadingAlert(false)
            })
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>My Report</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title="My Report" breadcrumbItem="Stock Reports"></Breadcrumb>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>

                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    
                                    <Row>
                                    <Col sm={12} md={4} className="mb-4-sm">
                                        <p>Location wise Stock Report</p>
                                        <Button
                                            color="primary"
                                            className="btn-sm center"
                                             onClick= {handleLocationstockPrint}
                                            
                                        >
                                            <i
                                                className="mdi mdi-clipboard-text"
                                                style={{ fontSize: "50px" }}
                                            ></i>
                                        </Button>
                                    </Col>  
                                    <Col sm={12} md={4} className="mb-4-sm">
                                    <p>Supplier wise Stock Report</p>
                                    <Button
                                        color="primary"
                                        className="btn-sm"
                                        onClick={handlesupplierStockPrint}
                                   
                                    >
                                        <i
                                            className="mdi mdi-clipboard-text"
                                            style={{ fontSize: "50px" }}
                                        ></i>
                                    </Button>
                                    </Col>
                                    <Col sm={12} md={4} className="mb-4-sm">
                                    <p>Group wise Stock Report</p>
                                    <Button
                                        color="primary"
                                        className="btn-sm "
                                        onClick={handleGroupstockPrint}
                                        
                                    >
                                        <i
                                            className="mdi mdi-clipboard-text"
                                            style={{ fontSize: "50px"}}
                                        ></i>
                                    </Button>
                                    </Col> 
                                    </Row>
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01T00:00:00' ? crDate : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01T00:00:00' ? mdDate : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )

}

export default StockReport